<template>
  <div v-bind:class="clazz">
    <div v-if="bestRoundPlayed" class="col-12 best-play mb-3">
      Meilleur coup ce tour :<br />
      <span class="font-italic">
        {{bestRoundPlayed.words[0].reference.split(' ')[0]}}</span>
      &nbsp;
      <strong>
        {{bestRoundPlayed.words[0].reference.split(' ')[1]}} {{bestRoundPlayed.total}}pts
      </strong>
    </div>
    <div class="col-12" v-if="!boardValid.valid">
      <span>{{boardValid.error}}</span>
    </div>
    <div v-if="boardValid.valid && boardValid.result" class="col-12">
      <div class="row">
        <span class="col-12" v-if="boardValid.result.valid">
          Coup valide {{boardValid.result.total}}pts
        </span>
        <span class="col-12" v-else>Coup invalide</span>
      </div>
      <div class="row" v-for="word in boardValid.result.words" v-bind:key="word.reference">
        <span class="col-7">
          {{word.reference.split(' ')[1]}}
          <font-awesome-icon icon="check" v-if="word.valid"/>
          <font-awesome-icon icon="times" class="error" v-else/>
        </span>
        <span class="col-5">{{word.points}} {{word.points | pluralize('pt')}}</span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'InfoBoard',
  props: {
    boardValid: Object,
    bestRoundPlayed: Object,
  },
  computed: {
    clazz() {
      return {
        invalid: !this.boardValid.valid
        || (this.boardValid && this.boardValid.result && !this.boardValid.result.valid),
        'text-info': this.boardValid.valid && this.boardValid.result && this.boardValid.result.valid,
        row: true,
        'play-success': this.boardValid.valid && this.boardValid.result && this.boardValid.result.valid,
      };
    },
  },
};
</script>

<style scoped>
.best-play {
  color: green;
}
.best-play strong{
  font-size: 1.2rem;
  letter-spacing: 2px;
  font-weight: normal;
}
.invalid {
  color: #CE0F69;
}
.play-success{
  background-color: #dff0d8;
}

</style>



// WEBPACK FOOTER //
// src/components/games/InfoBoard.vue